export const SIDE_NAV_EXPANDED_WIDTH = 240;
export const SIDE_NAV_COLLAPSED_WIDTH = 64;
export const TOP_NAV_HEIGHT = 64;

export const SIDE_NAV_OPEN_PARENTS_STORAGE_KEY = 'navbarV2_open_parents';

export const SIDE_NAV_TEST_IDS = {
    ROOT: 'sideNavV2Root',
    PORTFOLIO: 'sideNavV2Portfolio',
    DEAL_HOME: 'sideNavV2DealHome',
    COLLAPSE_TOGGLE: 'sideNavV2CollapseToggle',
    PROJECT_SELECTOR: 'sideNavV2ProjectSelector',
    LOADING: 'sideNavV2Loading',
    HEADER_DIVIDER: 'sideNavV2HeaderDivider',
    BACK_TO_PORTFOLIO: 'sideNavV2BackToPortfolio',
    SWITCHER_DROPDOWN: 'sideNavV2SwitcherDropdown',
    SWITCHER_DEAL_ITEM: 'sideNavV2SwitcherDealItem',
    TOP_NAV_COLLAPSE_TOGGLE: 'topNavV2CollapseToggle',
} as const;

export const BACK_TO_PORTFOLIO_LABEL = 'Back to portfolio';
export const SELECT_PROJECT_OR_DEAL_LABEL = 'Select project or deal';
export const ACTIVE_DEAL_LABEL = 'Active deal';

export const TOP_NAV_V2_USER_ICON_CLASS = 'top-nav-v2-user-icon';
export const TOP_NAV_V2_ICON_PARENT_CLASS = 'top-nav-v2-icon-parent';
